import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import Placeholder from '../Placeholder/index.js';
import Stack from '../Stack/index.js';
import Typography from '../Typography/index.js';
import Brandy from '../Brandy/index.js';
import Form from '../Form/index.js';
import Dots from './Dots.js';
import LoadingStep from './LoadingStep.js';
import Step from './Step.js';
import { MegaFormWrapper, MegaForm as MegaForm$2, Heading, Container, StepWrapper } from './MegaForm.styles.js';

var MegaForm = function MegaForm(_ref) {
  var _megaFormDisclaimer$b;
  var formId = _ref.formId,
    onSubmit = _ref.onSubmit,
    stepsData = _ref.stepsData,
    _ref$addressQualifica = _ref.addressQualificationCode,
    addressQualificationCode = _ref$addressQualifica === void 0 ? null : _ref$addressQualifica,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$disclaimer = _ref.disclaimer,
    disclaimer = _ref$disclaimer === void 0 ? null : _ref$disclaimer,
    _ref$fields = _ref.fields,
    fields = _ref$fields === void 0 ? null : _ref$fields,
    _ref$formDisclaimerPo = _ref.formDisclaimerPosition,
    formDisclaimerPosition = _ref$formDisclaimerPo === void 0 ? 'Below Submit Button' : _ref$formDisclaimerPo,
    _ref$formName = _ref.formName,
    formName = _ref$formName === void 0 ? null : _ref$formName,
    _ref$heading = _ref.heading,
    heading = _ref$heading === void 0 ? null : _ref$heading,
    _ref$subheading = _ref.subheading,
    subheading = _ref$subheading === void 0 ? null : _ref$subheading,
    _ref$isInsideModal = _ref.isInsideModal,
    isInsideModal = _ref$isInsideModal === void 0 ? false : _ref$isInsideModal,
    _ref$loadingDelayPerI = _ref.loadingDelayPerItem,
    loadingDelayPerItemProp = _ref$loadingDelayPerI === void 0 ? null : _ref$loadingDelayPerI,
    _ref$megaFormDisclaim = _ref.megaFormDisclaimer,
    megaFormDisclaimer = _ref$megaFormDisclaim === void 0 ? null : _ref$megaFormDisclaim,
    _ref$smartyStreetsWeb = _ref.smartyStreetsWebsiteKey,
    smartyStreetsWebsiteKey = _ref$smartyStreetsWeb === void 0 ? null : _ref$smartyStreetsWeb,
    _ref$spanish = _ref.spanish,
    spanish = _ref$spanish === void 0 ? false : _ref$spanish,
    _ref$submissionData = _ref.submissionData,
    submissionData = _ref$submissionData === void 0 ? {} : _ref$submissionData,
    _ref$submissionMessag = _ref.submissionMessage,
    submissionMessage = _ref$submissionMessag === void 0 ? null : _ref$submissionMessag,
    _ref$submitButtonText = _ref.submitButtonText,
    submitButtonText = _ref$submitButtonText === void 0 ? 'Submit' : _ref$submitButtonText,
    _ref$tcpaCheckbox = _ref.tcpaCheckbox,
    tcpaCheckbox = _ref$tcpaCheckbox === void 0 ? false : _ref$tcpaCheckbox;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLastStep = _useState2[0],
    setIsLastStep = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    currentStep = _useState4[0],
    setCurrentStep = _useState4[1];
  var _useState5 = useState(1),
    _useState6 = _slicedToArray(_useState5, 2),
    activeDot = _useState6[0],
    setActiveDot = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    loadingStepValues = _useState8[0],
    setLoadingStepValues = _useState8[1];

  // Taken from the cuttlefish implementation, this allows us to not
  // require the form to have an email_address field on the last step
  var _useState9 = useState(),
    _useState10 = _slicedToArray(_useState9, 2),
    stepValues = _useState10[0],
    setStepValues = _useState10[1];
  if (!(stepsData !== null && stepsData !== void 0 && stepsData[formId])) return /*#__PURE__*/React__default.createElement(Placeholder, {
    type: "error"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "small"
  }, "Error:"), /*#__PURE__*/React__default.createElement(Typography, null, "formId ", formId, " not found"), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement(Typography, null, "Double check that the correct formId is used as a key in the StepsData.jsx file"));

  // The number of navigation dots to render and the step data for the given guid in StepsData.jsx
  var _stepsData$formId = stepsData[formId],
    numberOfDots = _stepsData$formId.numberOfDots,
    loadingDelayPerItem = _stepsData$formId.loadingDelayPerItem,
    steps = _stepsData$formId.steps;

  // This allows us to pass in the delay amount per item as a prop but also pass the value from
  // StepsData.jsx if a user only wants to shadow that file to adjust this value
  var delay = loadingDelayPerItemProp || loadingDelayPerItem;

  // Title and options for the current step
  // [currentStep - 1] because steps is an array which is 0 indexed
  var _steps = steps[currentStep - 1],
    title = _steps.title,
    options = _steps.options;
  return /*#__PURE__*/React__default.createElement(MegaFormWrapper, {
    isInsideModal: isInsideModal,
    className: "leshen-mega-form-wrapper ".concat(isInsideModal ? 'is-inside-modal' : '')
  }, /*#__PURE__*/React__default.createElement(Stack, {
    className: "stack",
    spacing: "lg"
  }, /*#__PURE__*/React__default.createElement(MegaForm$2, {
    className: "leshen-mega-form"
  }, /*#__PURE__*/React__default.createElement(Heading, {
    className: "heading",
    variant: "h3"
  }, heading), megaFormDisclaimer && /*#__PURE__*/React__default.createElement(Brandy, {
    text: (megaFormDisclaimer === null || megaFormDisclaimer === void 0 || (_megaFormDisclaimer$b = megaFormDisclaimer.brandy) === null || _megaFormDisclaimer$b === void 0 ? void 0 : _megaFormDisclaimer$b.text) || megaFormDisclaimer
  }), /*#__PURE__*/React__default.createElement(Container, {
    className: "container"
  }, isLastStep ? /*#__PURE__*/React__default.createElement(LoadingStep, {
    loadingStepValues: loadingStepValues,
    loadingDelayPerItem: delay,
    className: "loading-step"
  }, /*#__PURE__*/React__default.createElement(Form, {
    formName: formName,
    fields: fields,
    submitButtonText: submitButtonText,
    onSubmit: onSubmit,
    initialStepValues: stepValues,
    disclaimer: disclaimer,
    submissionData: submissionData,
    customSubmissionMessage: submissionMessage,
    className: "form",
    smartyStreetsWebsiteKey: smartyStreetsWebsiteKey,
    addressQualificationCode: addressQualificationCode,
    spanish: spanish,
    tcpaCheckbox: tcpaCheckbox,
    formDisclaimerPosition: formDisclaimerPosition,
    subheading: subheading
  })) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Typography, {
    className: "title",
    variant: "h5"
  }, title), /*#__PURE__*/React__default.createElement(StepWrapper, {
    className: "step-wrapper"
  }, /*#__PURE__*/React__default.createElement(Step, {
    className: "step",
    key: title,
    data: options,
    setCurrentStep: setCurrentStep,
    setIsLastStep: setIsLastStep,
    stepValues: stepValues,
    setStepValues: setStepValues,
    activeDot: activeDot,
    setActiveDot: setActiveDot,
    loadingStepValues: loadingStepValues,
    setLoadingStepValues: setLoadingStepValues
  }))), /*#__PURE__*/React__default.createElement(Dots, {
    numberOfDots: numberOfDots,
    isLastStep: isLastStep,
    activeDot: activeDot,
    className: "dots"
  }))), children));
};
var MegaForm$1 = MegaForm;

export { MegaForm$1 as default };
//# sourceMappingURL=index.js.map
